import { clsx } from 'clsx'
import type { PlayerListItem } from '../types'
import styles from './InjuryBadge.module.css'

// ── Props ──────────────────────────────────────────────────────────────────────

type InjuryBadgeProps = {
  status:        PlayerListItem['injuryStatus']
  isEliminated?: boolean
}

// ── Helper ─────────────────────────────────────────────────────────────────────

// Maps an injury/suspension status to its badge presentation. null = healthy (no badge).
function badgeFor(status: PlayerListItem['injuryStatus']):
  { label: string; className: string | undefined; title: string } | null {
  switch (status) {
    case 'SUSPENDED':        return { label: 'SUS', className: styles.red,    title: 'Suspenso' }
    case 'INJURED_OUT':      return { label: 'LES', className: styles.red,    title: 'Lesionado — desfalque' }
    case 'INJURED_DOUBTFUL': return { label: 'LES', className: styles.yellow, title: 'Lesionado — dúvida' }
    default:                 return null
  }
}

// ── Component ──────────────────────────────────────────────────────────────────

export function InjuryBadge({ status, isEliminated = false }: InjuryBadgeProps) {
  // Elimination dominates: the player's nation is out and scores 0, so it takes
  // precedence over any injury/suspension state. Same red chip as SUS / LES.
  if (isEliminated) {
    return (
      <span className={clsx(styles.badge, styles.red)} title="Eliminado da competição">
        ELI
      </span>
    )
  }

  const badge = badgeFor(status)
  if (!badge) return null

  return (
    <span className={clsx(styles.badge, badge.className)} title={badge.title}>
      {badge.label}
    </span>
  )
}
